import * as React from 'react';
import { colors } from '../../config';

interface ISvgProps {
  src: string;
  width: number;
  className?: string;
  fill?: string;
  height?: number;
  opacity?: number;
  style?: object;
  onClick?: () => void;
}

export const Svg: React.SFC<ISvgProps> = ({
  className,
  fill,
  height,
  opacity,
  src,
  style,
  width,
  onClick,
}) => {
  const InnerSvg = require(`!svg-react-loader!../../assets/${src}.svg`);
  return (
    <InnerSvg
      fill={fill && colors[fill]}
      className={className}
      style={{ ...style, height, opacity, width }}
      onClick={onClick}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Svg.tsx